// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 获取当前用户有效银行卡列表 GET /api/v1/hq/user/bankcard/${param0} */
export async function HqUserBankcardControllerGetActiveBankcardListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqUserBankcardControllerGetActiveBankcardListV1Params,
  options?: { [key: string]: any }
) {
  const { userId: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputUserBankcardDtoArray>(
    `/api/v1/hq/user/bankcard/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 查看用户银行卡绑定状态并同步通道解绑 GET /api/v1/hq/user/bankcard/${param0}/binding-status */
export async function HqUserBankcardControllerGetUserBankcardBindingStatusV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqUserBankcardControllerGetUserBankcardBindingStatusV1Params,
  options?: { [key: string]: any }
) {
  const { userId: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputUserBankcardBindingStatusDto>(
    `/api/v1/hq/user/bankcard/${param0}/binding-status`,
    {
      method: "GET",
      params: {
        ...queryParams,
      },
      ...(options || {}),
    }
  );
}

/** 获取当前用户有效银行卡数量 GET /api/v1/hq/user/bankcard/${param0}/count */
export async function HqUserBankcardControllerGetActiveBankcardCountV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqUserBankcardControllerGetActiveBankcardCountV1Params,
  options?: { [key: string]: any }
) {
  const { userId: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseNumber>(
    `/api/v1/hq/user/bankcard/${param0}/count`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
